import get from 'lodash/get'
import * as FullStory from '@fullstory/browser'

const sendFullStoryUserData = userData => {
  const uid = userData.id
  const userVars = {
    displayName: userData.name,
    ...userData,
  }
  FullStory.identify(uid, userVars)
}

/**
 *
 * @param {Object} currentUser
 * @property {Object} currentUser.profile
 * @property {Object} currentUser.info
 * @property {string} bmcode
 * @property {string} createdAt
 * @property {string} email
 * @property {string} event
 * @property {string} id
 * @property {string} insToken
 * @property {string} interests
 * @property {string} name
 * @property {boolean} stripe_needs_updated_payment
 * @property {string} universityName
 * @property {string} userType
 */
export const sendUserData = currentUser => {
  const name = get(currentUser, 'profile.name')
  const id = get(currentUser, '_id')
  const userType = get(currentUser, 'info.userType')
  const shortName = window.location.hostname.split('.')[0]

  if (currentUser && currentUser !== '') {
    const {
      bmcode,
      createdAt,
      email,
      insToken,
      interests,
      stripe_needs_updated_payment,
      universityName = shortName,
    } = currentUser

    const userData = {
      ...(bmcode && { bmcode }),
      ...(createdAt && { createdAt }),
      ...(email && { email }),
      ...(id && { id }),
      ...(insToken && { insToken }),
      ...(interests && { interests }),
      ...(name && { name }),
      ...(stripe_needs_updated_payment && { stripe_needs_updated_payment }),
      ...(universityName && { universityName }),
      ...(userType && { userType }),
    }
    sendFullStoryUserData(userData)
  }
}



// WEBPACK FOOTER //
// ./src/utils/analyticsHelpers/index.js